<template>
  <div :class="this.$store.state.turboShopShow ? 'active-turbo-shop' : ''" class="turbo-shop">
    <div class="badge-new"><div>جديد</div></div>
    <svg
      width="139"
      height="61"
      viewBox="0 0 139 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M119.988 6.231H109.563C107.91 6.28316 106.322 6.88538 105.058 7.94027C103.793 8.99517 102.925 10.4411 102.595 12.0442L101.393 18.7891C101.23 19.5026 101.235 20.2437 101.408 20.9549C101.581 21.6662 101.917 22.3286 102.391 22.8906C102.864 23.4527 103.462 23.8995 104.138 24.1963C104.814 24.4931 105.55 24.632 106.289 24.6022H116.713C118.367 24.5504 119.954 23.9483 121.219 22.8933C122.483 21.8384 123.351 20.3923 123.681 18.7891L124.884 12.0442C125.047 11.3306 125.042 10.5895 124.869 9.87826C124.696 9.16699 124.36 8.50466 123.886 7.94256C123.413 7.38047 122.815 6.93372 122.139 6.63691C121.463 6.3401 120.727 6.20122 119.988 6.231ZM117.749 18.7908H107.325L108.523 12.0442H118.949L117.749 18.7908Z"
        fill="#31006F"
      />
      <path
        d="M74.6773 6.23071H67.0056C65.3597 6.28856 63.7818 6.89393 62.527 7.94888C61.2722 9.00383 60.414 10.4466 60.0913 12.0439L57.8523 24.6037H63.7299L65.9689 12.0439H73.6397L74.6773 6.23071Z"
        fill="#31006F"
      />
      <path
        d="M94.3272 6.23096H83.9698L85.0091 0.418701H79.1549L78.1138 6.23096L77.078 12.0441L75.8748 18.7881C75.7069 19.4964 75.7061 20.2333 75.8726 20.9419C76.0391 21.6504 76.3684 22.3115 76.8349 22.874C77.3014 23.4364 77.8925 23.885 78.5626 24.185C79.2326 24.485 79.9635 24.6284 80.6986 24.604H91.0561C92.6991 24.5438 94.2735 23.9372 95.5247 22.8823C96.7758 21.8273 97.6305 20.3858 97.9505 18.7908L99.1493 12.0441C99.3169 11.3362 99.3174 10.5996 99.1508 9.89148C98.9843 9.18333 98.6551 8.52261 98.1888 7.96052C97.7226 7.39842 97.1317 6.95004 96.4621 6.65011C95.7924 6.35019 95.0619 6.20677 94.3272 6.23096ZM92.0882 18.7908H81.7308L82.9358 12.0441H93.2933L92.0882 18.7908Z"
        fill="#31006F"
      />
      <path
        d="M31.2543 11.9835L32.281 6.22829H24.2364L25.2713 0.418701H19.3945L16.1738 18.4772L16.1144 18.814C15.948 19.5201 15.9482 20.2546 16.1151 20.9606C16.282 21.6666 16.6111 22.3251 17.0768 22.885C17.5425 23.4449 18.1323 23.8912 18.8006 24.1893C19.4688 24.4874 20.1975 24.6293 20.9301 24.604H29.0027L30.0393 18.7908H21.9956L23.2097 11.9862L31.2543 11.9835Z"
        fill="#31006F"
      />
      <path
        d="M0 12.0439H13.9231L14.9598 6.23071H1.03665L0 12.0439Z"
        fill="#E80505"
      />
      <path
        d="M57.6899 6.23071H51.8122L49.5741 18.7905H39.3653L41.6025 6.23071H35.7195L34.6828 12.0439H34.69L33.4885 18.7888C33.322 19.498 33.3228 20.2356 33.491 20.9445C33.6591 21.6534 33.99 22.3145 34.458 22.8765C34.926 23.4385 35.5186 23.8864 36.1898 24.1855C36.8611 24.4846 37.5929 24.6267 38.3286 24.601H48.5375C50.1829 24.5428 51.7603 23.9374 53.0147 22.8827C54.2691 21.8279 55.1271 20.3855 55.4499 18.7888L57.0882 9.60583L57.6899 6.23071Z"
        fill="#31006F"
      />
      <path
        d="M122.676 0C123.072 0.00234323 123.461 0.103125 123.807 0.293063C124.17 0.484623 124.468 0.776879 124.666 1.13395C124.867 1.47889 124.973 1.86996 124.974 2.26819C124.975 2.66643 124.87 3.05791 124.67 3.40363C124.474 3.75864 124.179 4.05092 123.82 4.24629C123.472 4.44314 123.078 4.54669 122.676 4.54669C122.275 4.54669 121.881 4.44314 121.533 4.24629C121.174 4.05072 120.878 3.75853 120.681 3.40363C120.481 3.0597 120.376 2.67045 120.375 2.27413C120.377 1.87406 120.483 1.48124 120.684 1.13395C120.883 0.777098 121.182 0.484974 121.545 0.293063C121.891 0.103017 122.28 0.00223211 122.676 0M122.676 0.375904C122.346 0.378049 122.021 0.463258 121.733 0.623538C121.429 0.7838 121.179 1.02759 121.012 1.32546C120.843 1.61256 120.753 1.93887 120.752 2.2713C120.751 2.60374 120.839 2.93047 121.007 3.21835C121.172 3.51467 121.419 3.75844 121.719 3.92116C122.009 4.08571 122.338 4.17228 122.673 4.17228C123.007 4.17228 123.336 4.08571 123.627 3.92116C123.926 3.75794 124.172 3.51425 124.336 3.21835C124.503 2.92997 124.59 2.60344 124.589 2.27131C124.589 1.93918 124.5 1.61306 124.332 1.32546C124.166 1.02709 123.915 0.783131 123.611 0.623538C123.324 0.464078 123 0.379196 122.67 0.376795M121.66 3.5319V1.08496H122.511C122.723 1.0753 122.936 1.09813 123.141 1.15265C123.268 1.19545 123.377 1.27803 123.452 1.38782C123.527 1.49191 123.567 1.61641 123.567 1.74412C123.568 1.83083 123.552 1.91686 123.518 1.99716C123.485 2.07745 123.436 2.15042 123.374 2.21178C123.238 2.3478 123.055 2.42771 122.862 2.43536C122.939 2.46557 123.011 2.50966 123.072 2.56541C123.211 2.71331 123.334 2.8758 123.437 3.04999L123.739 3.52922H123.252L123.032 3.14352C122.933 2.94373 122.803 2.75993 122.648 2.59837C122.547 2.52233 122.422 2.48416 122.295 2.49059H122.06V3.53101L121.66 3.5319ZM122.06 2.15477H122.545C122.71 2.17103 122.876 2.13516 123.019 2.05233C123.059 2.02026 123.091 1.9795 123.113 1.93318C123.135 1.88686 123.146 1.83621 123.145 1.7851C123.147 1.72485 123.133 1.66508 123.102 1.61273C123.072 1.56039 123.027 1.51761 122.974 1.48936C122.828 1.43145 122.671 1.40767 122.514 1.41988H122.064L122.06 2.15477Z"
        fill="#31006F"
      />
      <path
        d="M88.9841 50.2082C88.5665 50.2082 88.1103 50.1807 87.6157 50.1258C87.1211 50.0818 86.6375 50.0269 86.1649 49.9609C85.7033 49.884 85.3076 49.818 84.9779 49.7631L85.1263 47.966C85.467 48.01 85.8627 48.0595 86.3133 48.1144C86.7639 48.1584 87.2091 48.1968 87.6487 48.2298C88.0994 48.2628 88.4895 48.2793 88.8193 48.2793C89.2369 48.2793 89.5776 48.2243 89.8414 48.1144C90.1052 48.0045 90.2976 47.8396 90.4185 47.6198C90.5504 47.389 90.6163 47.0977 90.6163 46.746C90.6163 46.4603 90.5558 46.2349 90.4349 46.0701C90.325 45.8942 90.1217 45.7568 89.8249 45.6579C89.5282 45.548 89.116 45.4436 88.5885 45.3447C87.929 45.2238 87.363 45.0809 86.8903 44.916C86.4287 44.7512 86.0495 44.5478 85.7528 44.306C85.456 44.0532 85.2362 43.7345 85.0933 43.3498C84.9614 42.9651 84.8955 42.498 84.8955 41.9484C84.8955 41.0911 85.0548 40.4207 85.3736 39.9371C85.6923 39.4425 86.1484 39.0908 86.742 38.8819C87.3355 38.6731 88.0334 38.5687 88.8357 38.5687C89.1985 38.5687 89.6106 38.5907 90.0722 38.6346C90.5449 38.6676 91.0065 38.7116 91.4571 38.7665C91.9187 38.8215 92.3089 38.8819 92.6277 38.9479L92.5287 40.7614C92.199 40.7174 91.8143 40.679 91.3747 40.646C90.946 40.602 90.5174 40.5636 90.0887 40.5306C89.6711 40.4976 89.3139 40.4811 89.0171 40.4811C88.6104 40.4811 88.2697 40.5251 87.9949 40.613C87.7202 40.701 87.5168 40.8383 87.3849 41.0252C87.253 41.212 87.1871 41.4484 87.1871 41.7341C87.1871 42.0638 87.253 42.3166 87.3849 42.4925C87.5168 42.6684 87.7366 42.8112 88.0444 42.9211C88.3631 43.0311 88.7973 43.1465 89.3468 43.2674C89.9953 43.4103 90.5449 43.5641 90.9955 43.729C91.4571 43.8939 91.8253 44.0917 92.1001 44.3225C92.3859 44.5533 92.5947 44.8501 92.7266 45.2128C92.8585 45.5755 92.9244 46.0316 92.9244 46.5812C92.9244 47.4604 92.765 48.1694 92.4463 48.7079C92.1386 49.2355 91.6879 49.6202 91.0944 49.862C90.5119 50.0928 89.8085 50.2082 88.9841 50.2082ZM94.5016 50.0269V38.7665H96.7767V43.4652H101.146V38.7665H103.421V50.0269H101.146V45.3776H96.7767V50.0269H94.5016ZM109.933 50.2082C108.735 50.2082 107.784 49.9994 107.081 49.5817C106.388 49.1531 105.888 48.5101 105.58 47.6528C105.284 46.7955 105.135 45.7239 105.135 44.4379C105.135 43.141 105.284 42.0584 105.58 41.1901C105.888 40.3218 106.388 39.6678 107.081 39.2282C107.784 38.7885 108.735 38.5687 109.933 38.5687C111.131 38.5687 112.076 38.7885 112.769 39.2282C113.472 39.6678 113.972 40.3218 114.269 41.1901C114.577 42.0584 114.73 43.141 114.73 44.4379C114.73 45.7458 114.577 46.8285 114.269 47.6858C113.972 48.5431 113.472 49.1805 112.769 49.5982C112.076 50.0049 111.131 50.2082 109.933 50.2082ZM109.933 48.2958C110.625 48.2958 111.147 48.1584 111.499 47.8836C111.862 47.5978 112.104 47.1692 112.225 46.5977C112.345 46.0151 112.406 45.2952 112.406 44.4379C112.406 43.5806 112.34 42.8607 112.208 42.2782C112.087 41.6847 111.851 41.2395 111.499 40.9428C111.147 40.635 110.625 40.4811 109.933 40.4811C109.251 40.4811 108.729 40.635 108.367 40.9428C108.015 41.2395 107.773 41.6847 107.641 42.2782C107.509 42.8607 107.443 43.5806 107.443 44.4379C107.443 45.2842 107.504 45.9931 107.625 46.5647C107.757 47.1362 107.998 47.5704 108.35 47.8671C108.713 48.1529 109.24 48.2958 109.933 48.2958ZM116.446 50.0269V38.7665H120.683C121.617 38.7665 122.392 38.8984 123.008 39.1622C123.623 39.415 124.085 39.8272 124.393 40.3987C124.711 40.9702 124.871 41.7341 124.871 42.6903C124.871 43.6466 124.711 44.4269 124.393 45.0314C124.085 45.6249 123.623 46.0646 123.008 46.3504C122.392 46.6251 121.617 46.7625 120.683 46.7625H118.721V50.0269H116.446ZM118.721 44.8995H120.617C121.31 44.8995 121.804 44.7182 122.101 44.3555C122.398 43.9818 122.546 43.4322 122.546 42.7068C122.546 41.9594 122.398 41.4264 122.101 41.1076C121.804 40.7889 121.31 40.6295 120.617 40.6295H118.721V44.8995Z"
        fill="#E80505"
      />
    </svg>
    <p>يمكنك الان التسوق داخل تربو شوب وطلب منتجات التغليف و غيرها .</p>
    <a target="_blank" :href="idToken">
      <svg
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.10279 1.43568L1.88192 3.06351C1.64011 3.38593 1.5192 3.54714 1.522 3.68208C1.52445 3.79951 1.57951 3.90963 1.67199 3.98204C1.77825 4.06525 1.97977 4.06525 2.38279 4.06525H13.9654C14.3684 4.06525 14.5699 4.06525 14.6762 3.98204C14.7687 3.90963 14.8237 3.79951 14.8262 3.68208C14.829 3.54714 14.7081 3.38593 14.4663 3.06351L13.2454 1.43568M3.10279 1.43568C3.24053 1.25203 3.3094 1.16021 3.39668 1.09398C3.47398 1.03532 3.56152 0.991551 3.65483 0.964902C3.76018 0.934814 3.87496 0.934814 4.10453 0.934814H12.2437C12.4732 0.934814 12.588 0.934814 12.6934 0.964902C12.7867 0.991551 12.8742 1.03532 12.9515 1.09398C13.0388 1.16021 13.1077 1.25203 13.2454 1.43568M3.10279 1.43568L1.63148 3.39742C1.44565 3.64521 1.35273 3.7691 1.28674 3.90554C1.22819 4.0266 1.18549 4.15471 1.15969 4.28669C1.13062 4.43543 1.13062 4.5903 1.13062 4.90003L1.13062 14.0826C1.13062 14.9592 1.13062 15.3975 1.30121 15.7324C1.45128 16.0269 1.69072 16.2663 1.98524 16.4164C2.32006 16.587 2.75836 16.587 3.63496 16.587L12.7132 16.587C13.5898 16.587 14.0281 16.587 14.3629 16.4164C14.6575 16.2663 14.8969 16.0269 15.047 15.7324C15.2176 15.3975 15.2176 14.9592 15.2176 14.0826V4.90003C15.2176 4.5903 15.2176 4.43543 15.1885 4.2867C15.1627 4.15471 15.12 4.0266 15.0614 3.90554C14.9955 3.7691 14.9025 3.64521 14.7167 3.39742L13.2454 1.43568M11.3045 7.19568C11.3045 8.02593 10.9747 8.82216 10.3876 9.40923C9.80057 9.9963 9.00434 10.3261 8.17409 10.3261C7.34385 10.3261 6.54761 9.9963 5.96054 9.40923C5.37347 8.82216 5.04366 8.02593 5.04366 7.19568"
          stroke="white"
          stroke-width="1.56522"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      من هنا
    </a>
    <div v-if="this.$store.state.turboShopShow" class="turbo-shop-now">
      <h6>يوجد الأن</h6>
      <svg
        width="52"
        height="52"
        viewBox="0 0 52 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M45.5 43.3334H38.1333C30.8527 43.3334 27.2123 43.3334 24.4315 41.9165C21.9854 40.6701 19.9966 38.6814 18.7502 36.2353C17.3333 33.4544 17.3333 29.8141 17.3333 22.5334V8.66675M17.3333 8.66675L28.1667 19.5001M17.3333 8.66675L6.5 19.5001"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: localStorage.getItem("activeTurboShop"),
      idToken: 'https://shop.turbo-eg.com/turbo-user?token='+JSON.parse(localStorage.getItem('userData')).idToken
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";
.turbo-shop {
  grid-column: span 3;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px 14px;
  text-align: center;
  position: relative;
  svg {
    margin-bottom: 21px;
  }
  p {
    font-size: 14px;
    font-weight: 600;
    line-height: 27px;
    margin: auto;
    // margin-bottom: 27px;
    color: #000;
    max-width: 280px;
  }
  a {
    svg {
      margin: 0px;
      transition: 0.3s ease-in-out;
    }
    // width: fit-content;
    // margin-left: auto;
    background-color: $mainColor1;
    border: 1px solid $mainColor1;
    display: flex;
    align-items: center;
    border-radius: 40px;
    padding: 6px 13px;
    gap: 8px;
    color: #ffffff;
    position: absolute;
    right: 14px;
    bottom: 24px;
    transition: 0.3s ease-in-out;
    &:hover {
      border: 1px solid $mainColor1;
      background-color: #fff;
      color: $mainColor1;
      svg {
        fill: $mainColor1;
      }
    }
  }
}
.active-turbo-shop {
  outline: 9999px solid rgba(0, 0, 0, 0.5);
  z-index: 999999;
  transition: 0.3s;
}
.turbo-shop-now {
  position: absolute;
  bottom: -84px;
  display: flex;
  align-items: center;
  gap: 8px;
  left: 50%;
  transform: translateX(-50%);
  h6 {
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    line-height: 47px;
  }
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
